<template>
    <div class="box tqm">
        <div class="box-head bg-color1 felx-between">
            <el-page-header @back="goBack" :content="pageTitle" style="color:#AECFDC;width:300px;"></el-page-header>
            <!-- <div class="box-head-title color1 flex-algin">
                工人不良记录查询管理 &nbsp;&nbsp;&nbsp;&nbsp;
                <i class="el-icon-arrow-down color1" style="margin-left:10px;"></i>
            </div> -->
            <!-- <el-button type="primary" class="bg-color2" @click="toInfo">验收</el-button> -->
        </div>
        <div class="box-table">
            <el-table
            :data="tableList"
            height="100%"
            style="width: 100%;border:0;height:100%;"
            :header-cell-class-name="tableHeadCellName"
            :header-row-class-name="tableHeadRowName"
            :row-class-name="tableRowClassName">
                <el-table-column prop="projectName" label="来源项目" align="center"></el-table-column>
                <el-table-column prop="personName" label="姓名" align="center"></el-table-column>
                <el-table-column prop="badRecordType" label="不良事项" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.badRecordType=='0'">不服从项目管理</span>
                        <span v-else-if="scope.row.badRecordType=='1'">违章操作</span>
                        <span v-else-if="scope.row.badRecordType=='2'">恶意讨薪</span>
                        <span v-else-if="scope.row.badRecordType=='3'">恶意欠薪</span>
                        <span v-else>其他</span>
                    </template>
                </el-table-column>
                <el-table-column prop="desc" label="事项描述" align="center"></el-table-column>
                <el-table-column prop="createDate" label="时间" align="center"></el-table-column>
                <!-- <el-table-column prop="address" label="验收人" align="center"></el-table-column> -->
                <!-- <el-table-column label="查看" align="center">
                  <template slot-scope="scope" v-if="scope.row.id">
                    <el-button size="mini" type="primary" class="bg-color5">历史</el-button>
                  </template>
                </el-table-column> -->
            </el-table>
        </div>
        <!-- <div style="width:100%;">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 20, 30, 50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalItems"
                style="padding-top:10px;">
            </el-pagination>
        </div> -->
    </div>
</template>
<script>
import myHttp from '../../untils/port'
import util from '../../untils/util'
export default {
    data(){
        return{
            tableList:[],
            tableHeadCellName:'table-head-cell',
            tableHeadRowName:'table-head-row',
            // currentPage:1,
            // pageSize:10,
            // totalItems:0,
            pageTitle:'',
            id:'',
        }
    },
    mounted(){
        this.groupId = this.$store.state.groupId
        if ('' == this.groupId || undefined == this.groupId) {
            this.groupId = util.session.get('groupId')
        }
        this.id = this.$route.params.id
        this.getData()
    },
    methods:{
        handleSizeChange(val) {
            this.pageSize = val
            this.handleCurrentChange(this.currentPage)
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.currentChangePage();
        },
        // 监控当前页码
        currentChangePage(list) {
            this.getData();
        },
        //获取数据
        getData(){
            var that = this
            myHttp.secBadRecordByEntIdAndJoinType({
                joinType:'3',
                personId:this.id,
                entId:this.groupId,
                pageNum:this.currentPage,
                pageSize:this.pageSize
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var　list = resp.data.data.list||[]
                    that.tableList = list
                    that.pageTitle = list[0].personName||''
                }
            })
        },

        tableRowClassName({row, rowIndex}) {
            // if (rowIndex%2 === 0) {
            // return 'full-row';
            // } else if (rowIndex%2 === 1) {
            // return 'null-row';
            // }
            return 'full-row';
        },
        //跳转详情
        toInfo(){
            this.$router.push({ path: '/tqmInfo' })
        },
        //返回
        goBack(){
            this.$router.go(-1)
        },
    },
}
</script>
<style scoped>
    *{
        box-sizing: border-box;
    }
    .box{
        width: 100%;
        position: relative;
        height: calc( 100vh - 170px );
        background: #010D27;
    }
    .box-head{
        width: 100%;
        height: 40px;
        position: relative;
        display: flex;
        padding: 0 20px;
    }
    .box-table{
        width: 100%;
        height: calc( 100% - 40px );
        position: relative;
        /* overflow: auto; */
    }
    .el-table .box-head-title{
        font-size: 16px;
    }


    .flex-algin{
        display: flex;
        align-content: center;
        align-items: center;
    }
    .felx-between{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .bg-color1{
        background: #001498;
    }
    .bg-color2{
        background: #0D2DFF;
    }
    .bg-color3{
        background: #FFBC01;
    }
    .bg-color4{
        background: #36C635;
    }
    .bg-color5{
        background: #886CFF;
    }
    .color1{
        color: #17B2FE;
    }
    .color2{
        color: #886CFF;
    }
</style>
<style>
    .tqm .el-table .table-head-cell,.tqm .table-head-row{
        /* background: #010D27; */
        color: #4C9AFF;
        font-size: 18px;
        text-align: center;
    }
    .tqm .el-table .full-row{
        /* background: #031260 !important; */
        color: #4C9AFF;
        font-size: 18px;
        text-align: center;
    }
    .tqm .el-table .null-row{
        /* background: #010D27 !important; */
        border: 0;
        height: 10px;
        
    }
    .tqm .el-table .el-table__empty-block{
        /* background: #031260; */
        color: #4C9AFF;
        font-size: 18px;
        border: 0;
    }
    /* .tqm .el-table td,.tqm .el-table th.is-leaf{
        border: 0;
        border-bottom: 10px solid #010d27;
    } */
    .tqm .el-pagination{
        background: inherit;
    }
    .tqm .el-table--enable-row-hover .el-table__body tr:hover>td,.el-table, .el-table__expanded-cell{
        background-color:inherit;
    }
    .tqm .el-page-header__content{
        color: #AECFDC;
    }
</style>